module.exports = __webpack_public_path__ + "static/media/New_LOGO.46a7f1c2.png";